
<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('complain.complain_request') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xs="12" sm="12" md="6">
            <b-form-group
              class="row"
              label-cols-sm="3"
              :label="$t('complain.organization')"
              label-for="org_id"
            >
              <b-form-select
                plain
                id="org_id"
                v-model="search.org_id"
                :options="orgList"
                >
                <template v-slot:first>
                  <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="6">
            <b-form-group
              class="row"
              label-cols-sm="3"
              :label="$t('complain.service')"
              label-for="service_id"
            >
              <b-form-select
                plain
                id="service_id"
                v-model="search.service_id"
                :options="serviceList"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
            <b-col xs="12" sm="12" md="6">
                <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('complain.division')"
                label-for="division_id"
                >
                <b-form-select
                    plain
                    id="division_id"
                    v-model="search.division_id"
                    :options="divisionList"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6">
                <b-form-group
                class="row"
                label-cols-sm="3"
                :label="$t('complain.district')"
                label-for="district_id"
                >
                <b-form-select
                    plain
                    id="district_id"
                    v-model="search.district_id"
                    :options="districtList"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" sm="12" md="6">
            <b-form-group
              class="row"
              label-cols-sm="3"
              :label="$t('complain.upazila')"
              label-for="upazilla_id"
            >
              <b-form-select
                plain
                id="upazilla_id"
                v-model="search.upazilla_id"
                :options="upazilaList"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="6">
            <b-form-group
              class="row"
              label-cols-sm="3"
              :label="$t('complain.union')"
              label-for="union_id"
            >
              <b-form-select
                plain
                id="union_id"
                v-model="search.union_id"
                :options="unionList"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('complain.complain_request') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loading">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table bordered hover :items="listData" :fields="columns"  aria-hidden="loading | listReload ? 'true' : null">
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(com_title)="data">
                      <span class="capitalize">{{ data.item.com_title.substring(0,20)+".." }}</span>
                    </template>
                    <template v-slot:cell(org_id)="data">
                      <span class="capitalize">{{ data.item.org_id }}</span>
                    </template>
                    <template v-slot:cell(service_id)="data">
                      <span class="capitalize">{{ data.item.service_id }}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button class="mr-1" title="View Complain" v-b-modal.modal-5 variant=" iq-bg-success border" size="sm" @click="edit(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                      <b-button v-if="data.item.status !== 3 && data.item.status !== 4 && data.item.status !== 6" class="mr-1"  title="Add Committee" v-b-modal.modal-6 variant=" iq-bg-success border" size="sm" @click="addCommittee(data.item)"><i class="ri-add-line m-0 "></i></b-button>
                      <b-button v-if="data.item.status !== 3 && data.item.status !== 4 && data.item.status !== 6" class="mr-1" title="Complain Report" v-b-modal.modal-4 variant=" iq-bg-success border" size="sm" @click="edit(data.item)"><i class="ri-edit-line"></i></b-button>
                      <b-button v-if="data.item.status !== 3 && data.item.status !== 4 && data.item.status !== 6" class="mr-1" title="Approve" v-b-modal.modal-1 variant=" iq-bg-success border" size="sm" @click="edit(data.item)"><i class="ri-check-line"></i></b-button>
                      <b-button v-if="data.item.status !== 3 && data.item.status !== 4 && data.item.status !== 6" title="Reject" v-b-modal.modal-2 variant=" iq-bg-danger border" size="sm" @click="reject(data.item)"><i class="ri-close-line"></i></b-button>
                      <b-button v-if="data.item.status !== 3 && data.item.status !== 4 && data.item.status !== 6" title="Send Compalin" v-b-modal.modal-send variant=" iq-bg-info border" size="sm" @click="sendComplain(data.item)"><i class="ri-send-plane-fill"></i></b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal  id="modal-1" size="lg" :title="$t('complain.complain_approve')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <ApproveModal :id="editItemId"/>
    </b-modal>
    <b-modal  id="modal-2" size="lg" :title="$t('complain.complain_reject')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <RejectModal :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-4" size="lg" :title="$t('complain.complain_report')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <ReportModal :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-5" size="lg" :title="$t('complain.complain_info_detail')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-6" size="xl" :title="$t('complain.committee_list')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <AddCommitteeModal :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-send" size="lg" :title="$t('complain.send_complain')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <SendModal :complainId="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import DetailModal from './DetailModal'
import ReportModal from './ReportSubmit'
import ApproveModal from './ApproveModal'
import RejectModal from './RejectModal'
import AddCommitteeModal from './AddCommittee'
import SendModal from './SendModal'
import RestApi, { commonServiceBaseUrl } from '../../../../../config/api_config'
import { complainRequestList } from '../../api/routes'

export default {
  name: 'UiDataTable',
  components: {
    DetailModal,
    ReportModal,
    RejectModal,
    ApproveModal,
    AddCommitteeModal,
    SendModal
  },
  data () {
    return {
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: this.$store.state.commonObj.perPage,
        slOffset: 1
      },
      search: {
        com_title: '',
        org_id: 0,
        service_id: 0,
        division_id: 0,
        district_id: 0,
        upazilla_id: 0,
        union_id: 0
      },
      editItemId: 0,
      rows: [],
      services: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      complain_detail: '',
      commonServiceBaseUrlImg: commonServiceBaseUrl
    }
  },
  computed: {
    formTitle () {
       return (this.editItemId === 0) ? this.$t('org_pro.org_profile') + ' ' + this.$t('globalTrans.entry') : this.$t('org_pro.org_profile') + ' ' + this.$t('globalTrans.modify')
    },
    loading () {
      return this.$store.state.commonObj.loading
    },
    listReload () {
      return this.$store.state.commonObj.listReload
    },
    loadingState () {
      if (this.listReload) {
        return true
      } else if (this.loading) {
        return true
      } else {
        return false
      }
    },
    listData () {
      return this.$store.state.Complain.complainRequestList
    },
    orgList: function () {
      return this.$store.state.orgList.filter(item => item.status === 0)
    },
    serviceList () {
      const services = this.$store.state.commonObjCommonConfig.serviceList.filter(item => item.status === 0)
      const listData = services.map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
      return listData
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('complain.com_titlel'), class: 'text-left' },
          { label: this.$t('complain.organization'), class: 'text-left' },
          { label: this.$t('complain.service'), class: 'text-left' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'com_title_bn' },
          { key: 'org_name_bn' },
          { key: 'service_name_bn' },
          { key: 'status_name_bn' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'com_title' },
          { key: 'org_name' },
          { key: 'service_name' },
          { key: 'status_name' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    loadingState: function (newVal, oldVal) {
      if (newVal) {
        this.loadData()
      }
    },
    'search.division_id': function (newVal, oldVal) {
    this.districtList = this.getDistrictList(newVal)
    },
    'search.district_id': function (newVal, oldVal) {
    this.upazilaList = this.getUpazilaList(newVal)
    },
    'search.upazilla_id': function (newVal, oldVal) {
    this.unionList = this.getUnionList(newVal)
    }
  },
  async created () {
    this.loadData()
  },
  mounted () {
    core.index()
  },
  methods: {
    resetId () {
      this.editItemId = 0
    },
    testClick () {
      this.loadData()
    },
    default () {
      return {
        id: this.rows.length,
        org_name: '',
        org_name_bn: '',
        establishment_year: '',
        about_org: '',
        about_org_bn: '',
        mission: '',
        mission_bn: '',
        vision: '',
        vision_bn: '',
        logo: '',
        hierarchy: ''
      }
    },
    paginationData (data) {
      this.pagination.currentPage = data.current_page
      this.pagination.totalRows = data.total
      this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
    },
    async searchData () {
      this.loadData()
    },
    edit (item) {
      this.editItemId = item.id
    },
    reject (item) {
      this.editItemId = item.id
    },
    sendComplain (item) {
      this.editItemId = item.id
    },
    addCommittee (item) {
      this.editItemId = item.id
    },
    async loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      const result = await RestApi.getData(commonServiceBaseUrl, complainRequestList, params)
      if (result.success) {
        this.$store.dispatch('Complain/addComplainRequestList', this.getRelationalData(result.data.data))
        this.paginationData(result.data)
      }
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    getRelationalData (data) {
        const statusList = this.$store.state.commonObj.comStatusList
        return data.map(item => {
          const statusObj = statusList.find(statusItem => statusItem.id === item.status)
          const statusData = {
            status_name: statusObj.name,
            status_name_bn: statusObj.name_bn
          }
          return Object.assign({}, item, statusData)
        })
    },
    getDistrictList (divisionId = null) {
        const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

        if (divisionId) {
            return districtList.filter(district => district.division_id === divisionId)
        }

        return districtList
    },
    getUpazilaList (districtId = null) {
        const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

        if (districtId) {
            return upazilaList.filter(upazila => upazila.district_id === districtId)
        }

        return upazilaList
    },
    getUnionList (upazilaId = null) {
        const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
        if (upazilaId) {
            return unionList.filter(union => union.upazilla_id === upazilaId)
        }

        return unionList
    }
  }
}
</script>
